import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "trakers_spot",
    object: "traker",
    header: [
      { text: "Conductor", value: "driver", sortable: false },
      { text: "Auto", value: "car", sortable: false },
      { text: "Origen", value: "origen" },
      { text: "Estado", value: "status" },
      { text: "Motivo de cancelación", value: "cancel_reason" },
      { text: "Fecha", value: "created_at" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions,
  },
  getters: {
    ...genericStore.getters
  }
};
